import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { RxComposite } from '../model/rx-composite';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { RxButtonModule } from '@nrwl/rx-button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';
import { DragDropDirective } from './drag-drop.directive';

@Component({
  selector: 'rx-upload-zone',
  templateUrl: './rx-upload-zone.component.html',
  styleUrls: ['./rx-upload-zone.component.scss'],
  imports: [CommonModule, FormsModule, RxIconModule, RxButtonModule, DragDropDirective],
  standalone: true,
})
export class RxUploadZoneComponent extends RxComposite implements OnInit {
  @ViewChild('input', { static: true }) input: ElementRef;

  files: any[] = [];

  public error = false;

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {}

  onActive() {
    this.input.nativeElement.click();
  }

  onChange(e) {
    if (e.target.files.length === 0) {
      return;
    }
    this.onError(false);
    this.files = [];
    const file = e.target.files[0];

    if (file.type !== this.file.jpg && file.type !== this.file.png) {
      this.error = true;
      return;
    } else {
      this.error = false;
    }

    const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
    this.files.push({ file, url });
    this.setupReader();
    e.preventDefault();
    e.stopPropagation();
    this.input.nativeElement.value = '';
  }

  onError(e) {
    this.error = e;
  }

  setupReader() {
    const formData: FormData = new FormData();
    formData.append('photo', this.files[0].file);
    this.payload.formData = formData;
  }

  remove() {
    this.files = [];
    this.payload.formData = null;
  }

  filesDropped(files: any): void {
    this.files = files;
    this.setupReader();
  }
}
